var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgProteinDiscovery = function SvgProteinDiscovery(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1786 14.0821C47.5509 11.0029 46.1671 7.39423 43.0879 6.02199C40.0087 4.64975 36.4 6.03352 35.0278 9.11274L29.0669 22.4886C27.6946 25.5678 29.0784 29.1765 32.1576 30.5487C35.2368 31.9209 38.8455 30.5372 40.2177 27.458L46.1786 14.0821Z",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5308 19.089C23.5811 19.089 26.0538 16.6163 26.0538 13.566C26.0538 10.5157 23.5811 8.043 20.5308 8.043C17.4805 8.043 15.0078 10.5157 15.0078 13.566C15.0078 16.6163 17.4805 19.089 20.5308 19.089Z",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0479 31.325C16.0982 31.325 18.5709 28.8523 18.5709 25.802C18.5709 22.7517 16.0982 20.279 13.0479 20.279C9.99763 20.279 7.5249 22.7517 7.5249 25.802C7.5249 28.8523 9.99763 31.325 13.0479 31.325Z",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0369 21.161C16.5759 20.202 17.1149 19.243 17.6539 18.291",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8029 44.184C41.1599 40.509 46.2069 32.907 46.2069 24.129C46.2069 11.746 36.1689 1.715 23.7929 1.715C11.4169 1.715 1.37891 11.746 1.37891 24.129C1.37891 34.013 7.77691 42.406 16.6669 45.388",
    stroke: "#7C7CF7",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6139 54.915C49.6929 49.994 44.7789 45.08 39.8579 40.159",
    stroke: "#7C7CF7",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0459 51.093C30.0214 51.093 34.0549 47.0595 34.0549 42.084C34.0549 37.1085 30.0214 33.075 25.0459 33.075C20.0703 33.075 16.0369 37.1085 16.0369 42.084C16.0369 47.0595 20.0703 51.093 25.0459 51.093Z",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProteinDiscovery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/protein-discovery.303179c5.svg";
export { ForwardRef as ReactComponent };